import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const get = async (url, params, fallback) => {
    try {
        const r = await axios.get(`${base}${url}`, { params });
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const post = async (url, payload, fallback) => {
    try {
        const r = await axios.post(`${base}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

// ── Shared lookups ───────────────────────────────────────────────────────────

export const getCostCenterTypes = () => get('/Accounts/GetCostCenterTypes', {}, 'Failed to fetch cost centre types');
export const getCCFinancialYear = () => get('/Accounts/GetCCFinancialYear', {}, 'Failed to fetch financial years');
export const getCostCenterSubTypes = () => get('/Accounts/GetCostCenterSubTypes', {}, 'Failed to fetch cost centre sub types');
export const getMasterWorkFlowStatus = (Masterids, Roleid) => get('/Accounts/GetMasterWorkFlowStatus', { Masterids, Roleid }, 'Failed to fetch workflow status');
export const getCostCenters = ({ CCTypeID, SubType }) => get('/Accounts/GetCostCenters', { CCTypeID, SubType }, 'Failed to fetch cost centres');

// ── CC Budget ────────────────────────────────────────────────────────────────

export const getCCDetails = ({ Roleid, FnYear, CCSubType, CCType }) =>
    get('/Accounts/GetCCDetails', { Roleid, FnYear, CCSubType, CCType }, 'Failed to fetch cost centre budget details');

export const saveCCAssignedBudget = (payload) => post('/Accounts/SaveCCAssignedBudget', payload, 'Failed to save cost centre budget');
export const saveCCAmendBudget = (payload) => post('/Accounts/SaveCCAmendBudget', payload, 'Failed to save budget amendment');

export const getBudgetAssignedCCByID = ({ CCCode, Year }) =>
    get('/Accounts/GetBudgetAssignedCCByID', { CCCode, Year }, 'Failed to fetch cost centre budget');

export const getOtherBudgetCCs = ({ CCCode, CCTypeval, CCYear }) =>
    get('/Accounts/GetOtherBudgetCCs', { CCCode, CCTypeval, CCYear }, 'Failed to fetch other cost centres');

// ── DCA Budget ───────────────────────────────────────────────────────────────

export const getBudgetAssignedCCByCCType = ({ CCtypeId, SubType, FnYear }) =>
    get('/Accounts/GetBudgetAssignedCCByCCType', { CCtypeId, SubType, FnYear }, 'Failed to fetch cost centres');

export const getDCABudgetDetails = ({ CCCode, Subtype, Year, CCTypeId }) =>
    get('/Accounts/GetDCABudgetDetails', { CCCode, Subtype, Year, CCTypeId }, 'Failed to fetch account head budget details');

// CCs with an approved CC budget and no account head budget yet (legacy AssignDCABudget list, spGetBudgetCostCenters)
export const getBudgetCostCenters = () => get('/Accounts/GetBudgetCostCenters', {}, 'Failed to fetch cost centres');
// CCid is the CC code (spGetCCDetailsbyID matches CC_Code), not CC_Id
export const getCCDetailsbyID = (CCid) => get('/Accounts/GetCCDetailsbyID', { CCid }, 'Failed to fetch cost centre details');
export const getBudgetDCADetails = (CcTypeID) => get('/Accounts/GetBudgetDCADetails', { CcTypeID }, 'Failed to fetch account heads');
export const saveDCAAssignedBudget = (payload) => post('/Accounts/SaveDCAAssignedBudget', payload, 'Failed to save account head budget');
export const saveSingleDCAAmendBudget = (payload) => post('/Accounts/SaveSingleDCAAmendBudget', payload, 'Failed to save amendment');
export const deleteDCAAmendBudget = (payload) => post('/Accounts/DeleteDCAAmendBudget', payload, 'Failed to remove staged amendment');
export const getAmendedDCA = (CCCode) => get('/Accounts/GetAmendedDCA', { CCCode }, 'Failed to fetch pending amendments');

export const getUnAmendedDCAByCCID = ({ CCCode, CCtype, SubType, FnYear }) =>
    get('/Accounts/GetUnAmendedDCAByCCID', { CCCode, CCtype, SubType, FnYear }, 'Failed to fetch unbudgeted account heads');

export const assignDCABudgetFromAmendment = (payload) => post('/Accounts/AssignDCABudgetFromAmendment', payload, 'Failed to add new account head budget');
export const multipleDCAAmend = (payload) => post('/Accounts/MultipleDCAAmend', payload, 'Failed to confirm amendments');
